import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';
import LoadingSpinner from '../ui/LoadingSpinner';

export function RequireAuth({ children, adminOnly = false, fallback }) {
  const { currentUser, loading } = useAuth();
  const location = useLocation();
  const [isSystemAdmin, setIsSystemAdmin] = useState(false);
  const [checkingAdmin, setCheckingAdmin] = useState(true);

  useEffect(() => {
    async function checkSystemAdmin() {
      if (!currentUser) {
        setCheckingAdmin(false);
        return;
      }

      try {
        const systemAdminsDoc = await getDoc(doc(db, 'systemSettings', 'system_admins'));
        if (systemAdminsDoc.exists()) {
          const { systemAdmins = [] } = systemAdminsDoc.data();
          setIsSystemAdmin(systemAdmins.includes(currentUser.uid));
        }
      } catch (error) {
        console.error('Error checking system admin status:', error);
      }
      setCheckingAdmin(false);
    }

    checkSystemAdmin();
  }, [currentUser]);

  if (loading || checkingAdmin) {
    return (
      <div className="flex justify-center items-center h-screen">
        <LoadingSpinner size="large" color="indigo" />
      </div>
    );
  }

  // Ha nincs bejelentkezve és van fallback, akkor azt jelenítjük meg
  if (!currentUser) {
    return fallback || <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Admin route-ok ellenőrzése
  if (adminOnly && !isSystemAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
} 